<div [class.after]="isContentAfter" class="unit-tag">
  <ng-content />

  @if (unitTag) {
    <myre-tag
      [customBackgroundColor]="inputTagConfig.backgroundColor"
      [customTextColor]="inputTagConfig.textColor"
      [text]="unitTag"
      [type]="inputTagConfig.type"
    />
  }
</div>

<div class="input-container">
  <input
    #input
    (blur)="onBlur()"
    (focus)="onFocus()"
    (ngModelChange)="onChange($event)"
    [attr.placeholder]="placeholder | translate"
    [class.number]="isTypeNumber"
    [class.secondary]="secondary"
    [class.display-only]="displayOnly"
    [class.hidden]="isTypeNumber && readonly"
    [disabled]="disabled"
    [id]="id"
    [max]="max"
    [min]="min"
    [ngModel]="value"
    [readonly]="readonly"
    [mask]="mask"
    [type]="mask ? 'text' : isTypeNumber ? 'number' : elementType"
    autocomplete="off"
    class="input"
    [required]="required"
  />

  @if (isTypeNumber && (!focused || readonly)) {
    <span
      (click)="formattedClick()"
      [attr.readonly]="readonly || disabled"
      [class.display-only]="displayOnly"
      [class.secondary]="secondary"
      class="formatted"
    >
      {{ formatted }}
    </span>
  }
</div>

@if (picto && type !== 'search') {
  <i
    [class.left-picto]="!isRightPicto"
    [class.right-picto]="isRightPicto"
    [class.secondary]="secondary"
    class="{{ picto }}"
  ></i>
}

@if (type === 'search') {
  <button
    (click)="onSearchClick()"
    class="sub-button search"
    tabindex="-1"
    type="button"
  >
    <i class="myre-icon-search"></i>
  </button>
}

@if (type === 'password') {
  <button
    (click)="togglePasswordVisibility()"
    class="sub-button"
    tabindex="-1"
    type="button"
  >
    <i
      [class.active]="elementType === 'text'"
      class="myre-icon-visibility eye-icon"
    ></i>
  </button>
}

@if (type === 'phone') {
  <button class="sub-button" tabindex="-1" type="button">
    <a [phone]="input.value">
      <i class="myre-icon-phone"></i>
    </a>
  </button>
}

@if (type === 'email') {
  <button class="sub-button" tabindex="-1" type="button">
    <a [email]="input.value">
      <i class="myre-icon-email"></i>
    </a>
  </button>
}

@if (tooltip) {
  <myre-tooltip [ref]="input" [show]="focused">
    {{ tooltip | translate }}
  </myre-tooltip>
}
